import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OutkeepPermissionService } from '../services/permission/outkeep-permission.service';
import { AppRoutePaths } from '@core/types/app-route-paths';
import { filter, map, of, switchMap, take } from 'rxjs';
import { AccountService } from '@core/services/account/account.service';

export const canUseAppGuard: CanActivateFn = () => {
  const router = inject(Router);
  const accountService = inject(AccountService);
  const permissionService = inject(OutkeepPermissionService);

  return accountService.authState$.pipe(
    filter(state => state !== 'unknown'),
    take(1),
    switchMap(state => {
      // Для анонима не проверяем права клиента: login уже открыт userGuard'ом,
      // а deep link должен остаться в адресной строке до reload после входа.
      if (state === 'anonymous') {
        return of(true);
      }

      return permissionService.canLogistUseBetaOutkeep$.pipe(
        map(isAllow => {
          if (!isAllow) {
            return router.createUrlTree([AppRoutePaths.NoPermission]);
          }

          return true;
        }),
      );
    }),
  );
};
